import type { ReactNode } from 'react'

import { enableHistorySync, NuqsAdapter } from 'nuqs/adapters/react'

enableHistorySync()

export function NuqsProvider({ children }: { children: ReactNode }) {
  return <NuqsAdapter>{children}</NuqsAdapter>
}
